export default __webpack_public_path__ + "static/media/vuexy-login-bg.640b7b14.jpg";